import React, { useContext, useRef, useState } from 'react'
import { Modal } from 'antd';
import ReuseModal from '../input/ReuseModal';
import Input from '../input/Input';
import { toast } from 'react-toastify';
import { useReactToPrint } from 'react-to-print'
import { UserContext } from '../../stores/Context/Context';
import { useDispatch, useSelector } from 'react-redux';
import { applicationSubmission } from '../../stores/slices/appIntake/applicationSubmissionSlice';
import { patientDetailsUpdate } from '../../stores/slices/appIntake/updatePatientSlice';
import { PARTNER_BROWSER_ID, systemData } from '../../constant/Constants';
import moment from 'moment';
import { getPatientDetails, resetPatientSearch, setProgramSpecificPatientId } from '../../stores/slices/patientSearch/patientSearchSlice';
import { setUpdatePatientData } from '../../stores/slices/appIntake/applicationSubmissionSlice';
import { useNavigate } from 'react-router';
import Loader from '../menu/Loader';
import { setConditionalRoute } from '../../stores/slices/generalConfiguration/routeRestrictionSlice';
import CPRTermsAndCoditions from './CPRTermsAndCoditions';
import FAFTermsAndCoditions from './FAFTermsAndConditions';
import { resetPreQualSubmitData } from '../../stores/slices/preQual/preQualValidateSlice';
import { resetPreQualQuestions } from '../../stores/slices/preQual/preQualQuestionsSlice';
import { resetFundLists } from '../../stores/slices/preQual/preQualFundsListSlice';
import { resetTreatingPhysician } from '../../stores/slices/appIntake/searchProviderSlice';
import { fetchViewAppDetails, getMemberDetails, resetAppViewDetails, resetInitialTab } from '../../stores/slices/appViewDetailsSlice';
import { resetApplicationsDocLists } from '../../stores/slices/document/documentListSlice';
import { fetchAppListsCPR, fetchAppListsFAF, resetApplicationUpdateflage } from '../../stores/slices/applicationsSlice';
import { updateRequiredActionFlage } from '../../stores/slices/requiredActionsSlice';
import CprPrintTerms from './CprPrintTerms';
import FafPrintTerms from './FafPrintTerms';
import { getAllSessions } from '../../utilities/API/supertokenServices';

function Authorization() {
  const loginStatus = useSelector((state) => state.loginSlice);
  const sessionData = useSelector((state) => state.sessionSlice)
  const preQual = useSelector((state) => state.preQualValidateSlice.success)
  const appSubmitData = useSelector((state) => state.applicationSubmissionSlice);
  const [open, setOpen] = useState(false);
  const [cancelModal, setCancelModal] = useState(false)
  const [termsChecked, setTermsChecked] = useState({
    terms1: false,
    terms2: false
  })
  const [isAgreed, setIsAgreed] = useState(false)
  const [optIn, setOptIn] = useState(true)
  const [updatePatientReq, setUpdatePatientReq] = useState();
  const patientDetails = useSelector(state => state.patientSearchSlice)
  const preAuth = useSelector((state) => state.preAuthSlice);
  const loginData = useSelector((state) => state.loginSlice);
  const [trigerLoader, setTriggerLoader] = useState(false);
  const [allowCreateApp, setAllowCreateApp] = useState(true);
  const dispatch = useDispatch()

  // get getProviderDetails data from store in searchProviderSlice
  const getProviderDetails = useSelector((state) => state.searchProviderSlice.searchProviderData);
  const appIntakeSteps = useSelector(state => state.preQualValidateSlice.success.appIntakeSteps)
  let wizardValidation = useContext(UserContext)
  const navigate = useNavigate()

  const componentRef = useRef()
  const prgData = patientDetails.patientInformation.Program
  const disclaimerUrl = prgData == "CPR" ? "https://totalassist.org/disclaimer" : "https://www.patientadvocate.org/connect-with-services/financial-aid-funds/"

  const reusemodal = (e) => {
    setCancelModal(false)
  }



  const authorizationValidate = () => {
    if (termsChecked.terms1 & termsChecked.terms2) {
      setOpen(false)
      setIsAgreed(true)
    } else {
      toast.error("Please Agree Our Terms and Conditions")
    }
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const validateAuthorization = () => {
    if (isAgreed && allowCreateApp) {
      setAllowCreateApp(false);
      const reqBody = {
        "PartnerPatient": {
          "CommsOptIn": optIn,
          "CorrPreferences": patientDetails.patientInformation.contactDetails.methodOfContact,
          "DateOfBirth": moment(patientDetails.patientInformation.dateOfBirth).format('YYYYMMDD'),
          "EmailOwner": patientDetails.patientInformation.contactDetails.emailOwner,
          "EmailType": patientDetails.patientInformation.contactDetails.emailType,
          "EmploymentStatus": patientDetails.patientInformation.additionalInformation.employementStatus,
          "GenderCode": patientDetails.patientInformation.additionalInformation.gender,
          "HispanicOrLatino": patientDetails.patientInformation.additionalInformation.hispanicOrgin,
          "HouseholdSize": patientDetails.patientInformation.additionalInformation.housHoldSize,
          "IsAuthPersonAvailable": patientDetails.isAuthorizedPersonAvailable,
          "IsDeceased": "false",
          "MaritalStatus": patientDetails.patientInformation.additionalInformation.maritalStatus,
          "PatientID": patientDetails.patientInformation.partnerPatientId,
          "FAFRefID": '',
          'CPRRefID': '',
          "PrimaryEmail": patientDetails.patientInformation.contactDetails.email,
          "PreferredLanguage": patientDetails.patientInformation.contactDetails.preferedLanguage,
          "PreferredPhoneNumber": patientDetails.patientInformation.contactDetails.phoneNumber,
          "SocialSecurityNumber": patientDetails.patientInformation.ssn,
          "SocialSecurityNumber_Input": patientDetails.patientInformation.ssn,
          "AlienNumber": patientDetails.patientInformation.alienNumber,
          'AlienNumber_Input': patientDetails.patientInformation.alienNumber,
          "pxObjClass": "PAF-Data-PartnerPatient",
          "pyFirstName": patientDetails.patientInformation.firstName,
          "pyLastName": patientDetails.patientInformation.lastName,
          "UnDocumented": "false",
          "VeteranClassification": patientDetails.patientInformation.additionalInformation.veteran,
          "Address": [
            {
              "AddressLine1": patientDetails.patientInformation.address.addressLine1,
              "AddressLine2": patientDetails.patientInformation.address.addressLine2,
              "City": patientDetails.patientInformation.address.city,
              "Country": "US",
              "pxObjClass": "Embed-PegaHC-Address",
              "State": patientDetails.patientInformation.address.state,
              "Type": "Home",
              "ZipCode": patientDetails.patientInformation.address.zipCode,
              "IsVerified": patientDetails.patientInformation.address.isAddressVerified,
              "IsValid": patientDetails.patientInformation.address.isAddressVerified,
              "NoMatch": patientDetails.patientInformation?.address?.smartyStreetMatches?.NoMatch || false,
              "PartialMatch": patientDetails.patientInformation?.address?.smartyStreetMatches?.PartialMatch || false,
              "ExactMatch": patientDetails.patientInformation?.address?.smartyStreetMatches?.ExactMatch || false,
              "SecInfoNotMatch": patientDetails.patientInformation?.address?.smartyStreetMatches?.SecInfoNotMatch || false
            }
          ],
          "PhoneCommunication": [
            {
              "IsPrimary": "true",
              "PhoneNumber": patientDetails.patientInformation.contactDetails.phoneNumber,
              "PhoneType": patientDetails.patientInformation.contactDetails.phoneType,
              "pxObjClass": "Embed-PegaHC-Communication-Phone"
            }
          ],
        },
        // "SubmissionChannel": "Partner"
      }

      const race = []
      patientDetails?.patientInformation?.additionalInformation?.race?.map((data) => {
        if (data.value == "Other" && data.isChecked) {
          Object.assign(reqBody.PartnerPatient, {
            OtherRace: patientDetails?.patientInformation?.additionalInformation?.raceOther
          });
        }
        return data.isChecked && race.push({ "pxObjClass": "SingleValue-Text", "pyValue": data.value })
      })
      Object.assign(reqBody.PartnerPatient, { "Race": race })

      const authPersonList = []

      if (patientDetails.isAuthorizedPersonAvailable) {
        Object.keys(patientDetails.authorizedPerson).map((data) => {
          authPersonList.push({
            "IsToReceiveEmail": patientDetails.authorizedPerson[data].isCopySent,
            "pyEmail1": patientDetails.authorizedPerson[data].email.value,
            "PhoneNumber": patientDetails.authorizedPerson[data].phoneNumber.value,
            "PhoneType": patientDetails.authorizedPerson[data].phoneType.value,
            'IsAddressSameAsPatient': patientDetails.authorizedPerson[data].isAddressChecked,
            'IsContactSameAsPatient': patientDetails.authorizedPerson[data].isPhoneNumberChecked,
            "pxObjClass": "PAF-Embed-Guardian",
            "pyFirstName": patientDetails.authorizedPerson[data].firstName.value,
            "pyLastName": patientDetails.authorizedPerson[data].lastName.value,
            "pyNameSuffix": patientDetails.authorizedPerson[data].suffix.value,
            "RelationshipToPatient": patientDetails.authorizedPerson[data].relationshipToPatient.value,
            "AuthPersonAddressList": [
              {
                "AddressLine1": patientDetails.authorizedPerson[data].addressLine1.value,
                "AddressLine2": patientDetails.authorizedPerson[data].addressLine2.value,
                "City": patientDetails.authorizedPerson[data].city.value,
                "Country": "US",
                "ExactMatch": patientDetails.authorizedPerson[data].smartyStreetMatches.ExactMatch || false,
                "FullAddressLine": `${patientDetails.authorizedPerson[data].addressLine1.value} ${patientDetails.authorizedPerson[data].addressLine2.value}`,
                "IsValid": patientDetails.authorizedPerson[data].isAddressVerified,
                "IsVerified": patientDetails.authorizedPerson[data].isAddressVerified,
                "NoMatch": patientDetails.authorizedPerson[data].smartyStreetMatches.NoMatch || false,
                "PartialMatch": patientDetails.authorizedPerson[data].smartyStreetMatches.PartialMatch || false,
                "pxObjClass": "Embed-PegaHC-Address",
                "SecInfoNotMatch": patientDetails.authorizedPerson[data].smartyStreetMatches.SecInfoNotMatch || false,
                "State": patientDetails.authorizedPerson[data].state.value,
                "Type": "Home",
                "Verified": patientDetails.authorizedPerson[data].isAddressVerified,
                "ZipCode": patientDetails.authorizedPerson[data].zipcode.value,
              }
            ]
          })
        })
      }
      Object.assign(reqBody.PartnerPatient, { "AuthPersonList": authPersonList })

      if (patientDetails.patientInformation.hasGuardian) {
        const guardianObj = {
          "DateOfBirth": moment(patientDetails.patientInformation.guardianDetails.dateOfBirth).format('YYYYMMDD'),
          "EmploymentStatus": patientDetails.patientInformation.guardianDetails.employementStatus,
          "IsAddressSameAsPatient": patientDetails.patientInformation.guardianDetails.isAddressSameAsPatient,
          "IsContactSameAsPatient": patientDetails.patientInformation.guardianDetails.isPhoneNumberSameAsPatient,
          "pxObjClass": "PAF-Embed-Guardian",
          "pyEmail1": patientDetails.patientInformation.guardianDetails.email,
          "pyEmail1Type": patientDetails.patientInformation.guardianDetails.emailType,
          "pyFirstName": patientDetails.patientInformation.guardianDetails.firstName,
          "pyLastName": patientDetails.patientInformation.guardianDetails.lastName,
          "pyNameSuffix": patientDetails.patientInformation.guardianDetails.suffix,
          "RelationshipToPatient": patientDetails.patientInformation.guardianDetails.relationshipToPatient,
          "SocialSecurityNumber": patientDetails.patientInformation.guardianDetails.ssn,
          "AlienNumber": patientDetails.patientInformation.guardianDetails.alienNumber,
          'AlienNumber_Input': patientDetails.patientInformation.guardianDetails.alienNumber,
          "UnDocumented": "false",
          "GuardianAddressList": [
            {
              "AddressLine1": patientDetails.patientInformation.guardianDetails.address.addressLine1,
              "AddressLine2": patientDetails.patientInformation.guardianDetails.address.addressLine2,
              "City": patientDetails.patientInformation.guardianDetails.address.city,
              "Country": "US",
              "pxObjClass": "Embed-PegaHC-Address",
              "State": patientDetails.patientInformation.guardianDetails.address.state,
              "Type": "Home",
              "ZipCode": patientDetails.patientInformation.guardianDetails.address.zipCode,
              "IsVerified": patientDetails.patientInformation.guardianDetails.address.isGuardianAddressVerified,
              "IsValid": patientDetails.patientInformation.guardianDetails.address.isGuardianAddressVerified,
              "NoMatch": patientDetails.patientInformation?.guardianDetails?.address?.smartyStreetMatches?.NoMatch || false,
              "PartialMatch": patientDetails.patientInformation?.guardianDetails?.address?.smartyStreetMatches?.PartialMatch || false,
              "ExactMatch": patientDetails.patientInformation?.guardianDetails?.smartyStreetMatches?.ExactMatch || false,
              "SecInfoNotMatch": patientDetails.patientInformation?.guardianDetails?.address?.smartyStreetMatches?.SecInfoNotMatch || false
            }
          ],

          "PhoneCommunication": [{
            "PhoneNumber": patientDetails.patientInformation.guardianDetails.PhoneCommunication.phoneNumber,
            "PhoneType": patientDetails.patientInformation.guardianDetails.PhoneCommunication.phoneType,
            "pxObjClass": "Embed-PegaHC-Communication-Phone"
          }
          ]
        }
        Object.assign(reqBody.PartnerPatient, { "GuardianInformation": guardianObj })
      }

      const today = new Date();
      let utcDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), today.getSeconds(), today.getMilliseconds()));

      utcDate = JSON.stringify(utcDate).replace(/-/g, "").replace(/:/g, "").slice(1, -2) + " GMT";

      let createApp = {
        "FundID": preQual.preQualData.fundId,
        "PreQualPassed": "true",
        "Program": patientDetails.patientInformation.Program,
        "ProgramDescription": patientDetails.patientInformation.Program == 'CPR' ? "Co-Pay Relief" : "Financial Aid Funds",
        "ProgramID": patientDetails.patientInformation.Program == 'CPR' ? "1" : "3",
        "SubmissionChannel": "Partner",
        "PreQualReportID": preQual.personalInfo.PreQualReportID,
        "AdditionalInformation": {
          "CreatedBy": "Portal - Partner",
          "CopaysReferral": patientDetails.patientInformation.referredBy,
          "OtherCopay_Referral": patientDetails.patientInformation.referredBy == 'Other/Unknown' ? patientDetails.patientInformation.referredOther : '',
          "pxObjClass": "PAF-Embed-Patient-AdditionalInfo",
          "OtherProgramAssistance": patientDetails.patientInformation.additionalInformation.copayProgramsChecked,
          "Program": patientDetails.patientInformation.additionalInformation.copayProgramsChecked && patientDetails.patientInformation.additionalInformation.copayPrograms
        },
        "PortalUserDetails": {
          "EmailAddress": loginData.value.EmailAddress,
          "PortalType": "Partner",
          "ReferenceID": `E-${loginData.value.EIN}`,
          "PortalUserID": loginData.value.PortalUserID,
          "SubmissionChannel": "Partner"
        },
        "ApplicantInformation": {
          "ApplicantName": "Partner",
          "PhoneNumber": patientDetails.patientInformation.applicantInfo.applicantPhoneNumber,
          "pxObjClass": "PAF-Embed-Patient-ApplicantInfo",
          "pyFirstName": patientDetails.patientInformation.applicantInfo.applicantFirstName,
          "pyLastName": patientDetails.patientInformation.applicantInfo.applicantLastName,
          "RelationshipToPatient": "Partner"
        },
        "Attestation": {
          "IsPatientAgreed": "true",
          "SubmittedDateTime": utcDate,
          "pxObjClass": "PAF-Embed-Attestation",
          "EsignUserID": loginData.value.EmailAddress,
          "EsignIP": systemData.ipAddress,
          "ESignType": "Partner",
          "ESigDateTime": utcDate,
          "ESigSignature": `${patientDetails.patientInformation.applicantInfo.applicantFirstName} ${patientDetails.patientInformation.applicantInfo.applicantLastName}`,
          "IsPatientAuthorized": "true"
        },
      }
      if (appIntakeSteps.VerificationRequired == false && appIntakeSteps.DefaultPayee == "Other") {
        Object.assign(createApp, {
          "AwardPayable": {
            "FirstName": patientDetails.patientInformation.payableInformations.firstName,
            "LastName": patientDetails.patientInformation.payableInformations.lastName,
            "Address": [
              {
                "AddressLine1": patientDetails.patientInformation.payableInformations.address.addressLine1,
                "AddressLine2": patientDetails.patientInformation.payableInformations.address.addressLine2,
                "City": patientDetails.patientInformation.payableInformations.address.city,
                "ExactMatch": patientDetails.patientInformation.payableInformations.address.smartyStreetMatches.ExactMatch ? "true" : "false",
                "IsValid": patientDetails.patientInformation.payableInformations.address.isPayableAddressVerified,
                "IsVerified": "true",
                "NoMatch": patientDetails.patientInformation.payableInformations.address.smartyStreetMatches.NoMatch ? "true" : "false",
                "PartialMatch": patientDetails.patientInformation.payableInformations.address.smartyStreetMatches.PartialMatch ? "true" : "false",
                "SecInfoNotMatch": patientDetails.patientInformation.payableInformations.address.smartyStreetMatches.SecInfoNotMatch ? "true" : "false",
                "State": patientDetails.patientInformation.payableInformations.address.state,
                "ZipCode": patientDetails.patientInformation.payableInformations.address.zipCode
              }
            ]
          }
        })
      }
      if (patientDetails.patientInformation.referredBy == 'Healthcare Facility') {
        Object.assign(createApp.AdditionalInformation, {
          NameofFacility: patientDetails.patientInformation.healthCare.healthCareFacilityName,
          PhoneNumber: patientDetails.patientInformation.healthCare.healthCarePhoneNumber,
          PrimaryEmail: patientDetails.patientInformation.healthCare.healthCareEmail,
          EmailType: patientDetails.patientInformation.healthCare.healthCareEmailType,
          Address: [{
            AddressLine1: patientDetails.patientInformation.healthCare.healthCareAddressLine1,
            AddressLine2: patientDetails.patientInformation.healthCare.healthCareAddressLine2,
            City: patientDetails.patientInformation.healthCare.healthCareCity,
            pxObjClass: "Embed-PegaHC-Address",
            State: patientDetails.patientInformation.healthCare.healthCareState,
            ZipCode: patientDetails.patientInformation.healthCare.healthCareZipcode,
            "IsVerified": "true",
            "IsValid": patientDetails.patientInformation.healthCare.smartyStreetMatches.NoMatch || false,
            "NoMatch": patientDetails.patientInformation.healthCare.smartyStreetMatches.NoMatch || false,
            "PartialMatch": patientDetails.patientInformation.healthCare.smartyStreetMatches.PartialMatch || false,
            "ExactMatch": patientDetails.patientInformation.healthCare.smartyStreetMatches.SecInfoNotMatch || false,
            "SecInfoNotMatch": patientDetails.patientInformation.healthCare.smartyStreetMatches.ExactMatch || false
          }]
        })
      } else if (patientDetails.patientInformation.referredBy == 'Healthcare Professional') {
        Object.assign(createApp.AdditionalInformation, {
          pyFirstName: patientDetails.patientInformation.healthCare.sameAsHealthCare ? patientDetails.patientInformation.applicantInfo.applicantFirstName : patientDetails.patientInformation.healthCare.healthCareProfessionalFirstName,
          pyLastName: patientDetails.patientInformation.healthCare.sameAsHealthCare ? patientDetails.patientInformation.applicantInfo.applicantLastName : patientDetails.patientInformation.healthCare.healthCareProfessionalLastName,
          Title: patientDetails.patientInformation.healthCare.healthCareProfessionalPosition,
          NameofFacility: patientDetails.patientInformation.healthCare.healthCareProfessionalFacilityName,
          PhoneNumber: patientDetails.patientInformation.healthCare.sameAsHealthCare ? patientDetails.patientInformation.applicantInfo.applicantPhoneNumber : patientDetails.patientInformation.healthCare.healthCarePhoneNumber,
          PrimaryEmail: patientDetails.patientInformation.healthCare.healthCareEmail,
          EmailType: patientDetails.patientInformation.healthCare.healthCareEmailType,
          Address: [{
            AddressLine1: patientDetails.patientInformation.healthCare.healthCareAddressLine1,
            AddressLine2: patientDetails.patientInformation.healthCare.healthCareAddressLine2,
            City: patientDetails.patientInformation.healthCare.healthCareCity,
            pxObjClass: "Embed-PegaHC-Address",
            State: patientDetails.patientInformation.healthCare.healthCareState,
            ZipCode: patientDetails.patientInformation.healthCare.healthCareZipcode,
            "IsVerified": "true",
            "IsValid": patientDetails.patientInformation.healthCare.smartyStreetMatches.NoMatch || false,
            "NoMatch": patientDetails.patientInformation.healthCare.smartyStreetMatches.NoMatch || false,
            "PartialMatch": patientDetails.patientInformation.healthCare.smartyStreetMatches.PartialMatch || false,
            "ExactMatch": patientDetails.patientInformation.healthCare.smartyStreetMatches.SecInfoNotMatch || false,
            "SecInfoNotMatch": patientDetails.patientInformation.healthCare.smartyStreetMatches.ExactMatch || false
          }]
        })

      }

      if (preQual.appIntakeSteps.insurance == true && patientDetails.patientInformation.Program == 'FAF') {
        Object.assign(createApp, {
          "InsuranceInformation": {
            "HasHealthInsurance": preQual.preQualData.insuranceType != '' ? "Yes" : 'No',
            "InsuranceType": preQual.preQualData.insuranceType,

          },
        })
      } else if (preQual.appIntakeSteps.insurance == true) {
        Object.assign(createApp, {
          "InsuranceInformation": {
            "GroupNumber": patientDetails.insurance.groupNumber.value,
            "HasHealthInsurance": patientDetails.insurance.insuranceType.value != '' ? "Yes" : 'No',
            "HasMedicarePartD": patientDetails.insurance.medicarePart.checked == true ? "Yes" : "No",
            "HasMedicareSupplement": patientDetails.insurance.medicareSupplement.checked == true ? "Yes" : "No",
            "InsuranceType": patientDetails.insurance.insuranceType.value,
            "PhoneNumber": patientDetails.insurance.phoneNumber.value,
            "PlanType": patientDetails.insurance.planType.value,
            "PolicyNumber": patientDetails.insurance.policyID.value,
            "PrimaryInsuranceCarrier": patientDetails.insurance.primaryInsurance.isOther == false ? patientDetails.insurance.primaryInsurance.value : '',
            "pxObjClass": "PAF-Embed-InsuranceInformation",
            "PrimaryInsuranceOtherCarrier": patientDetails.insurance.primaryInsurance.isOther != false ? patientDetails.insurance.primaryInsurance.value : '',
            "SecondaryInsuranceCarrier": patientDetails.insurance.secondaryInsurance.checked == true ? "Yes" : "No",
            "SubscriberDateOfBirth": moment(patientDetails.insurance.DOB.value).format('MM/DD/YYYY') != "Invalid date" ? moment(patientDetails.insurance.DOB.value).format('MM/DD/YYYY') : "",
            "SubscriberName": patientDetails.insurance.subscriberName.value,
            "SupportsPrescriptonByPharm": 'Yes',
          },
        })
        if (patientDetails.insurance.secondaryInsurance.checked) {
          Object.assign(createApp.InsuranceInformation, {
            "SecondaryInsuranceInfo": {
              "pxObjClass": "PAF-Embed-InsuranceInformation",
              "SecondaryInsuranceName": patientDetails.insurance.isSecondaryInsurance.isOther == false ? patientDetails.insurance.isSecondaryInsurance.value : '',
              "SecondaryInsuranceOtherName": patientDetails.insurance.isSecondaryInsurance.isOther != false ? patientDetails.insurance.isSecondaryInsurance.value : ''
            }
          })
        }
      }

      let medicalObj = {}

      if(prgData == "CPR" && typeof getProviderDetails.PatientsCurrentMedicationList != "undefined" && getProviderDetails.PatientsCurrentMedicationList.length > 0){
        const savedMeds = getProviderDetails.PatientsCurrentMedicationList || [];
        const otherMed = savedMeds.find(item => (item.DrugName || item || "").toString().startsWith("Other"));
        if (otherMed) {
          medicalObj = {...medicalObj, ...{
            OtherDrugName: typeof getProviderDetails.OtherMedicationText != "undefined" ? getProviderDetails.OtherMedicationText : ""
          }}
        }
        medicalObj = {...medicalObj, ...{
          PatientsCurrentMedicationList: getProviderDetails.PatientsCurrentMedicationList
          }}
      } 

      if (preQual.appIntakeSteps.diagnosisInfo == true) {
        Object.assign(createApp, {
          "MedicalInformation":{ ...medicalObj, ...{
            "PrimaryDiagnosis": preQual.preQualData.diagnosis,
            "pxObjClass": "PAF-Embed-MedicalInformation",
            "DateofDiagnosis": moment(getProviderDetails.DateofDiagnosis).format('YYYYMMDD'),
          }
        }
        })
      }
      //Treating Physician Information
      if (preQual.appIntakeSteps.treatment == true) {
        // Object.assign(createApp, {
        //   "TreatingPhysician": {
        //     "NationalProviderIdentifier": "1144676180",
        //     "pxObjClass": "PAF-Data-Provider-Individual",
        //     "Address": [
        //       {
        //         "Fax": "999-999-9999",
        //         "PhoneNumber": "989-098-9999",
        //         "Email": "oil@gmail.com",
        //         "Extension": "9999999999",
        //         "pySelected": true
        //       },
        //       {
        //         "Fax": "422-916-7225",
        //         "PhoneNumber": "299-616-2867",
        //         "Email": "",
        //         "Extension": "",
        //         "pySelected": false
        //       }
        //     ]
        //   }
        // })

        Object.assign(createApp, {
          TreatingPhysician: {
            NationalProviderIdentifier: getProviderDetails.NationalProviderIdentifier,
            pxObjClass: "PAF-Data-Provider-Individual",

          }
        });
        if (getProviderDetails.isNewProvider) {
          Object.assign(createApp.TreatingPhysician, {
            IsNewTreatingPhysician: "true",
            OfficeContactEmail: getProviderDetails.TreatingPhysician.OfficeContactEmail,
            OfficeContactName: getProviderDetails.TreatingPhysician.OfficeContactName,
            pyFirstName: getProviderDetails.TreatingPhysician.pyFirstName,
            pyLastName: getProviderDetails.TreatingPhysician.pyLastName,
            PhysicianEmailAddress: getProviderDetails.TreatingPhysician.PhysicianEmailAddress,
            Address: [
              {
                AddressLine1: getProviderDetails.TreatingPhysician.Address[0].AddressLine1,
                AddressLine2: getProviderDetails.TreatingPhysician.Address[0].AddressLine2,
                City: getProviderDetails.TreatingPhysician.Address[0].City,
                Email: getProviderDetails.TreatingPhysician.PhysicianEmailAddress,
                Extension: getProviderDetails.TreatingPhysician.Address[0].Extension,
                Fax: getProviderDetails.TreatingPhysician.Address[0].Fax,
                PhoneNumber: getProviderDetails.TreatingPhysician.Address[0].PhoneNumber,
                PreferredAddress: "true",
                pxObjClass: "Embed-PegaHC-Address",
                pySelected: "true",
                State: getProviderDetails.TreatingPhysician.Address[0].State,
                Type: getProviderDetails.TreatingPhysician.Address[0].Type,
                ZipCode: getProviderDetails.TreatingPhysician.Address[0].ZipCode,
                "IsVerified": "true",
                "IsValid": getProviderDetails.TreatingPhysician.Address[0].IsValid,
                "NoMatch": getProviderDetails.TreatingPhysician.Address[0].NoMatch,
                "PartialMatch": getProviderDetails.TreatingPhysician.Address[0].PartialMatch,
                "ExactMatch": getProviderDetails.TreatingPhysician.Address[0].ExactMatch,
                "SecInfoNotMatch": getProviderDetails.TreatingPhysician.Address[0].SecInfoNotMatch
              }
            ]
          });
          Object.assign(createApp, {
            ProviderSearch: getProviderDetails.ProviderSearch
          })
        } else {
          Object.assign(createApp.TreatingPhysician, {
            Address: getProviderDetails.address
          })
        }
      }

      setUpdatePatientReq(reqBody)

      Object.assign(createApp, {
        'PatientInformation': { ...reqBody.PartnerPatient }
      })

      createApp.PatientInformation.PatientID = patientDetails.patientInformation.programSpecificPatientId;
      createApp.PatientInformation.pxObjClass = 'PAF-Data-Patient'

      setTriggerLoader(true)
      dispatch(applicationSubmission({ createApp, prgData }))
    } else {
      toast.error('Please view the Terms & Conditions')
    }
    return false
  }
  wizardValidation.formValidation.isValidate = validateAuthorization




  const updatePatientInPartner = () => {
    dispatch(setConditionalRoute({
      isFlag: false,
      currentFlow: '',
    }))
    dispatch(setProgramSpecificPatientId({ program: appSubmitData.program, patientId: appSubmitData.patientId }));
    let obj = {
      ...updatePatientReq
    }
    obj.PartnerPatient.FAFRefID = appSubmitData.program == 'FAF' ? appSubmitData.patientId : patientDetails.patientDetails.patientIdFAF;
    obj.PartnerPatient.CPRRefID = appSubmitData.program == 'CPR' ? appSubmitData.patientId : patientDetails.patientDetails.patientIdCPR;
    dispatch(fetchAppListsCPR({ Program: 'CPR', EIN: loginStatus.value.EIN, paramData : "" }))
    dispatch(fetchAppListsFAF({ Program: 'FAF', EIN: loginStatus.value.EIN, paramData : ""  }))
    dispatch(patientDetailsUpdate({ reqBody: obj, browserId: PARTNER_BROWSER_ID.ID, portalUserId: loginData.value.PortalUserID, prgData: 'PARTNER' }))
    dispatch(setUpdatePatientData());
    setTriggerLoader(false);
    dispatch(resetFundLists())
    dispatch(resetPreQualQuestions())
    dispatch(resetPreQualSubmitData())
    dispatch(resetTreatingPhysician())
    dispatch(resetPatientSearch())
    dispatch(resetAppViewDetails());
    dispatch(resetApplicationsDocLists());
    dispatch(resetInitialTab(8));
    dispatch(fetchViewAppDetails({ applicationID: appSubmitData.AppId, prgData: appSubmitData.program }))
    dispatch(getMemberDetails({ memberId: appSubmitData.patientId, prgData: appSubmitData.program }))
    dispatch(resetApplicationUpdateflage(true))
    dispatch(updateRequiredActionFlage(true))
    return navigate('/applications/Details')
  }


  appSubmitData.updatePatientData && updatePatientInPartner()

  return (
    <div >
      {trigerLoader ? <Loader /> : null}
      <ReuseModal
        data={cancelModal}
        change={reusemodal}
      />
      <div className="px-5 px-sm-10 mt-5">
        <div className="fw-medium fs-base text-start">{prgData == "CPR" ? "Patient Agreement, Disclosures, and Attestations:" : "Terms and Conditions:"}</div>
        <div className="grid columns-12 gap-4 gap-y-3 mt-3 mb-4">
          <div className="intro-y g-col-12 g-col-sm-12 text-center border-1 p-1 text-justify ">
            <p className="pt-0 fs-base">{prgData == "CPR" ? "The patient/authorized agent must review and agree to the Patient Agreement. This gives PAF permission to process the application. Click the View Patient Agreement button below." : "The patient/authorized agent must review and agree to the Patient Authorization, Disclosures, and Attestation agreement which gives PAF permission to process your application. To view the Terms and Conditions, click the “View Terms and Conditions” button."}</p>
          </div>
          <div className="intro-y g-col-12 g-col-sm-12 text-center border-1 p-1 pb-5">
            <button type="button" className="btn verifyAddres" onClick={() => setOpen(true)}>{prgData == "CPR" ? "VIEW PATIENT AGREEMENT" : "Terms and Conditions"}</button>
          </div>
        </div>
        <div className="fw-medium fw-bold fs-base text-start mt-2"> Opt-In </div>
        <Input
          type="switch"
          id="editableMode_switch"
          labelPosition="left"
          name="editable_Mode_switch"
          label={`${prgData == "CPR" ? "May the Patient Advocate Foundation and the TotalAssist Program use your contact information in the future to share printed and or electronic communications with you? Application updates will still be sent regardless of your choice." : "Can Patient Advocate Foundation Financial Aid Funds use your contact information in the future to share printed and/or electronic communications with you?"}`}
          value={optIn}
          onClick={(e) => setOptIn(e.target.checked)}
        />
        {prgData != "CPR" && <div className="grid columns-12 gap-4 gap-y-5 mt-3">
          <div className="intro-y g-col-12 g-col-sm-12 text-center border-1 mb-5">
            <p className="pt-0 fw-bold fs-base">**Note If you answer NO: "You will still continue to receive updates about the application."</p>
          </div>
        </div>}
        <div className={prgData == "CPR" ? "intro-y g-col-12 g-col-sm-12 text-center border-1 p-1 pb-5 mt-5" : "intro-y g-col-12 g-col-sm-12 text-center border-1 p-1 pb-5"}>
          <button type="button" className="btn verifyAddres" onClick={handlePrint}>{prgData == "CPR" ? "PRINT PATIENT AGREEMENT" : "Print Terms and Conditions"}</button>
        </div>
        <div className="fs-base text-justify mt-2">{prgData == "CPR" ? "For a complete copy of the Patient Advocate Foundation's TotalAssist program disclaimer and terms and conditions, Please click " : "For a complete copy of the Patient Advocate Foundation Financial Aid Funds disclaimer and terms and conditions, Please click "}<a href={disclaimerUrl} target="_blank" className='color-primary link' >here</a> </div>
      </div>
      <div style={{ display: "none" }}>
        {prgData == "CPR" && <CprPrintTerms ref={componentRef} />}
        {prgData == "FAF" && <FafPrintTerms ref={componentRef} />}
      </div>
      <Modal
        open={open}
        onOk={authorizationValidate}
        onCancel={() => setCancelModal(true)}
        width={800}
        cancelText='No'
        maskClosable={false}
        closeIcon={false}
        okText='Yes'     >
        {prgData == "CPR" && <CPRTermsAndCoditions setTermsChecked={setTermsChecked} termsChecked={termsChecked} />}
        {prgData == "FAF" && <FAFTermsAndCoditions setTermsChecked={setTermsChecked} termsChecked={termsChecked} />}
      </Modal>
    </div>
  )
}

export default Authorization